import { render } from "./CashierMenuListItemComponent.vue?vue&type=template&id=71b04650&scoped=true"
import script from "./CashierMenuListItemComponent.vue?vue&type=script&lang=js"
export * from "./CashierMenuListItemComponent.vue?vue&type=script&lang=js"

import "./CashierMenuListItemComponent.vue?vue&type=style&index=0&id=71b04650&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b04650"]])

export default __exports__